




























































































import Vue from 'vue'
import Component from 'vue-class-component'
import Table from '@/components/tables/Table.vue'
import TableSubRow from '@/components/tables/TableSubRow.vue'
import DepositPaymentsModal from '@/views/app/management/payments/components/DepositPaymentsModal.vue'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import Icon from '@/components/Icon.vue'
import { EPaymentStatus, EUserPermissions, IPayment } from '@zunta/configurations'
import { getPaidByLabel } from '@/utils/helpers'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import { User } from '@/classes/User'
import Api from '@/api'
import { ITableConfig } from '@/interfaces'
import StatusPayment from '@/components/statuses/StatusPayment.vue'
import PaymentMethodLabel from '@/components/labels/PaymentMethodLabel.vue'
import PreferredResidentPayersWidget from '@/views/app/management/payments/components/PreferredPayersForPayment.vue'

@Component({
  props: {
    deposit: {
      type: Object,
      required: true
    },
    isMPIList: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    PaymentMethodLabel,
    StatusPayment,
    DateTimeLabel,
    Icon,
    ResidentLabel,
    DepositPaymentsModal,
    TableSubRow,
    Table,
    PreferredResidentPayersWidget,
  }
})
export default class PaymentDepositsSubrow extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EUserPermissions: any = EUserPermissions
  EPaymentStatus: any = EPaymentStatus
  getPaidByLabel: Function = getPaidByLabel
  user: User = Api.getUser() as User
  paymentPreferredPayersForWidget: number | null = null
  widgetPayersPositionXPos = 0

  showLineItemsModal: boolean = false

  appliedTo: any[] = []

  filters: any = {
    skip: 0,
    deposit: this.$props.deposit.willowId,
    facilityId: this.$props.deposit.facility.id
  }
  payment: IPayment | null = null

  get config (): ITableConfig {
    const config: ITableConfig = {
      rowClick: this.showAppliedTo,
      fetchFunction: this.paymentsModuleInstance.loadDepositPayments,
      columns: [
        {
          minWidth: '100px',
          width: 10,
          key: 'id',
          label: 'Id'
        },
        {
          minWidth: '100px',
          width: 15,
          key: 'resident',
          label: 'Resident'
        },
        {
          minWidth: '100px',
          width: 11,
          key: 'hmo',
          label: 'HMO'
        },
        {
          minWidth: '100px',
          width: 15,
          key: 'paymentMethod',
          label: 'Payment Method'
        },
        {
          minWidth: '100px',
          width: 14,
          key: 'paidBy',
          label: 'Processed By'
        },
        {
          minWidth: '100px',
          width: 10,
          key: 'amount',
          label: 'Amount'
        },
        {
          minWidth: '100px',
          width: 10,
          key: 'date',
          label: 'Date'
        },
        {
          minWidth: '100px',
          width: 12,
          key: 'status',
          label: 'Status'
        }
      ]
    }

    // console.log(this.$props.deposit)
    // if (!this.$props.deposit.HMO) {
    //   config.columns.splice(2, 1)
    // }

    const spareWidth = 100 - config.columns.reduce((acc: number, column: any) => column.width + acc, 0)
    if (spareWidth > 0) {
      const additionalColWidth: number = Number((spareWidth / config.columns.length).toFixed(2))
      config.columns = config.columns.map((column: any) => {
        return {
          ...column,
          width: column.width + additionalColWidth
        }
      })
    }

    return config
  }

  get depositsPayments () {
    return this.$store.state.payments.depositPayments
  }

  mounted () {
    document.addEventListener('click', this.handleClickOutsidePayerWidget)
  }

  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutsidePayerWidget)
  }

  handleClickOutsidePayerWidget (event: MouseEvent) {
    const ref = this.$refs.payersWidget as Vue | HTMLElement | undefined
    if (!ref) return

    const el: HTMLElement = ref instanceof HTMLElement ? ref : (ref.$el as HTMLElement)

    const target = event.target as Node | null
    if (!target) return

    if (!el.contains(target)) {
      this.paymentPreferredPayersForWidget = null
    }
  }

  showAppliedTo (row: any) {
    this.payment = row.payment
    this.appliedTo = row.payment.appliedTo
    this.toggleLineItemsModal(true)
  }

  toggleLineItemsModal (value: boolean) {
    if (!value) {
      this.appliedTo = []
      this.payment = null
    }
    this.showLineItemsModal = value
  }

  togglePayersWidget (event: any, payment: Partial<IPayment>) {
    const rect = event.currentTarget.getBoundingClientRect()
    if (this.paymentPreferredPayersForWidget) {
      this.paymentPreferredPayersForWidget = null
      return
    }
    if (payment.id && payment.resident) {
      this.widgetPayersPositionXPos = rect.left + rect.width / 2
      this.paymentPreferredPayersForWidget = payment.id
    }
  }

  goToAndRememberRoute (options: any) {
    this.$locationManager.rememberAndGoTo(options)
  }
}
